import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledNotFound = {
  Root: styled.div`
    max-width: 360px;
    margin: 0 auto;
    padding: 0 16px 100px;
  `,
  Title: styled.p`
    color: ${Color.BLUE_DARK};
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;
    margin-bottom: 56px;
  `,
  PinnedNoteWrapper: styled.div`
    margin-top: 48px;
  `,
}
